import type { KeyboardEventHandler, MouseEventHandler } from 'react';
import { Loader2 } from 'lucide-react';
import { SearchIcon } from '@/components/icons';
import { Input } from '@/components/ui/input';

export const searchFieldInputClassName =
  'h-[var(--erp-control-height)] w-full min-w-0 rounded-none border-0 border-b border-b-gray-200 bg-transparent px-2 pr-8 text-[13px] text-inherit shadow-none placeholder:text-black/60 focus-visible:border-0 focus-visible:border-b focus-visible:border-b-main focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-100';

const iconButtonClassName =
  'absolute right-1 top-1/2 flex size-6 -translate-y-1/2 items-center justify-center transition-colors disabled:pointer-events-none disabled:opacity-50';

interface SearchInputControlProps {
  disabled?: boolean;
  invalid?: boolean;
  loading?: boolean;
  onBlur?: () => void;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  onOpenDialog: () => void;
  placeholder?: string;
  type?: string;
  value: string;
}

export const SearchInputControl = ({
  disabled = false,
  invalid = false,
  loading = false,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
  onOpenDialog,
  placeholder,
  type = 'text',
  value
}: SearchInputControlProps) => {
  const handleMouseDown: MouseEventHandler = event => {
    if (event.button === 2) {
      event.preventDefault();
    }
  };

  return (
    <div data-search-input-control className='relative flex w-full min-w-0 items-center' onMouseDown={handleMouseDown}>
      <Input
        type={type}
        disabled={disabled}
        value={value}
        autoComplete='off'
        onChange={event => onChange(event.target.value)}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        aria-invalid={invalid}
        className={`${searchFieldInputClassName} ${invalid ? 'border-b-red-500 focus-visible:border-b-red-600' : ''}`}
      />

      <button
        type='button'
        className={`${iconButtonClassName} ${invalid ? 'text-red-500 hover:text-red-600' : 'text-main hover:text-main-dark'}`}
        onClick={onOpenDialog}
        disabled={disabled}
      >
        {loading ? <Loader2 className='size-4 animate-spin' /> : <SearchIcon size={16} color='currentColor' />}
      </button>
    </div>
  );
};
